import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=af37b9c4&scoped=true"
import script from "./InventoryView.vue?vue&type=script&lang=js"
export * from "./InventoryView.vue?vue&type=script&lang=js"
import style0 from "./InventoryView.vue?vue&type=style&index=0&id=af37b9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af37b9c4",
  null
  
)

export default component.exports